module.exports = __webpack_public_path__ + "img/symbol_0.8644e5b4.png";